import { SlotCompactInfo } from '../models';
import { HubBrief } from '../../../administration';

export class AllocationViewRuleBriefLoad {
  public static readonly type = '[AllocationViewRuleBrief] Load';
  constructor(public payload: { compartmentId: number; hub: HubBrief; ruleId: number }) {}
}

export class AllocationViewRuleBriefSetCompartmentName {
  public static readonly type = '[AllocationViewRuleBrief] Set Compartment Name';
  constructor(public payload: { compartmentName: string }) {}
}
export class AllocationViewRuleBriefSetSlotCompactInfo {
  public static readonly type = '[AllocationViewRuleBrief] Set Slot Details';
  constructor(public payload: SlotCompactInfo) {}
}

export class AllocationViewRuleBriefInitialState {
  public static readonly type = '[AllocationViewRuleBrief] Set Initial State';
}
